import React, { useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";
import { VARIABLES } from "../../Constant";
import { useGlobalAPIQueryContext } from "@dev2_techwalnut/tw-api-query-hook";
import { useAPIQuery } from "../../../hooks/useAPIQuery";
import { Controller, useForm } from "react-hook-form";
import Select from "react-select";
import AssignSupplierToItemModal from "../../modals/Supplier/AssignSupplierToItem";
import CreateSupplierModal from "../../modals/Supplier/CreateSupplier";

const CreatePurchaseOrder = ({ modalCurrentItem, modal, closeModal }) => {
    const userID = secureLocalStorage.getItem("userID");
    const delay_time = VARIABLES.delayTime;
    const navigate = useNavigate();

    const { invalidateApi } = useGlobalAPIQueryContext();

    const {
        register,
        handleSubmit,
        formState: { errors },
        control,
        watch,
        setValue,
        reset,
    } = useForm();

    const currentItem = watch("item");
    const quantity = watch("quantity");
    const perQuantity = watch("per_quantity");
    const rate = watch("rate");

    console.log(modalCurrentItem);

    const TypeMasterQuery = useAPIQuery({
        key: "api/type-master",
        endpoint: "/api/type-master/",
    });

    const shipTo = TypeMasterQuery.useFetch({
        params: {
            q: "ship_to",
            c: "name",
        },
    });

    const cgst = TypeMasterQuery.useFetch({
        params: {
            q: "cgst",
            c: "name",
        },
    });

    const sgst = TypeMasterQuery.useFetch({
        params: {
            q: "sgst",
            c: "name",
        },
    });

    const TypeMasterDeliveryStatus = TypeMasterQuery.useFetch({
        params: {
            q: "terms_of_delivery",
            c: "category",
        },
    });

    console.log(TypeMasterDeliveryStatus.data);

    const backFromModal = () => {
        const button = document.createElement("button");
        button.className = "d-none";
        button.id = "close-modal-create-po-modal";
        button.setAttribute("data-bs-dismiss", `#create-po-modal`);
        document.body.appendChild(button);
        button.click();
        button.remove();
    };

    const { useCreate: useCreatePurchaseOrders } = useAPIQuery({
        key: "purchase-order",
        endpoint: "/api/purchase-order/",
    });
    const { mutate: createPurchaseOrder, isPending } = useCreatePurchaseOrders({
        retry: 3,
        successMessageFromServer: true,
        errorMessageFromServer: true,
        onSuccess: () => {
            invalidateApi({ key: "requierement-analysis" });
            reset({
                payment_terms: "",
                billed_to: null,
                terms_of_delivery: "",
                delivery_date: "",
                rate: null,
                per_quantity: null,
                transport_amount: null,
                ship_to: shipTo?.data?.results?.data[0]?.value,
                cgst: cgst?.data?.results?.data[0]?.value,
                sgst: sgst?.data?.results?.data[0]?.value,
            });
            setTimeout(() => {
                if (modal) {
                    closeModal();
                } else {
                    navigate(-1);
                }
            }, 2000);
        },
    });

    const { useFetch: useFetchGeneric } = useAPIQuery({
        key: "api/generic",
        endpoint: "/api/generic/",
    });

    const { data: genericData, isLoading: genericDataLoading } =
        useFetchGeneric({
            abortOnNewRequest: true,
            refetchOnWindowFocus: false,
            staleTime: 1000 * 60 * 3,
            retry: 3,
            keepPlaceholder: true,
            refetchOnReconnect: true,
        });

    const { useFetch } = useAPIQuery({
        key: "supplier-item",
        endpoint: "/api/supplier-item-association/",
    });

    const { data: supplierItemData, isLoading: supplierDataLoading } = useFetch(
        {
            abortOnNewRequest: true,
            refetchOnWindowFocus: false,
            staleTime: 1000 * 60 * 3,
            retry: 3,
            keepPlaceholder: true,
            refetchOnReconnect: true,
        }
    );

    const parseNumber = (value) => {
        const num = Number(value);
        return isNaN(num) ? 0 : num;
    };

    const amount = parseNumber(watch("amount"));
    const sgstField = parseNumber(watch("sgst"));
    const cgstField = parseNumber(watch("cgst"));
    const transport = parseNumber(watch("transport_amount"));
    const total_inclusive = amount + transport;

    const total =
        total_inclusive +
        (total_inclusive * sgstField) / 100 +
        (total_inclusive * cgstField) / 100;

    const onSubmit = (data) => {
        console.log(data);
        createPurchaseOrder({
            data: {
                supplier_id: data.supplier.value,
                item_id: data.item.value,
                payment_terms: data.payment_terms,
                billed_to: data.billed_to,
                ship_to: data.ship_to,
                terms_of_delivery: data.terms_of_delivery?.value,
                delivery_date: data.delivery_date,
                quantity: data.quantity,
                per_quantity: data.per_quantity,
                rate: data.rate,
                amount: data.amount,
                // invoice_no: data.invoice,
                cgst: data.cgst,
                sgst: data.sgst,
                transport_amount: data.transport_amount || 0,
                created_by: userID,
                updated_by: userID,
            },
        });
    };

    const suppliers = useMemo(() => {
        // setModalCurrentItem?.(currentItem);
        if (currentItem && supplierItemData) {
            setValue("supplier", null);
            return supplierItemData?.results?.data
                ?.filter((si) => si?.item?.id === currentItem?.value)
                .map((si) => ({
                    ...si,
                    value: si?.supplier?.id,
                    label:
                        si?.supplier?.user?.first_name +
                        " " +
                        si?.supplier?.user?.last_name,
                }));
        }
    }, [currentItem, supplierItemData]);

    useEffect(() => {
        if (modalCurrentItem) {
            setValue("item", {
                ...modalCurrentItem,
                value: modalCurrentItem?.id,
                label: modalCurrentItem?.item_name,
            });
            setValue("quantity", modalCurrentItem?.order_quantity);
        }
    }, [modalCurrentItem]);

    console.log(currentItem);
    console.log(genericData);

    useEffect(() => {
        const safePerQuantity = Number(perQuantity) || 0;
        const safeRate = Number(rate) || 0;
        const safeQuantity = Number(quantity) || 0;

        if (
            safePerQuantity <= 0 ||
            isNaN(safePerQuantity) ||
            isNaN(safeRate) ||
            isNaN(safeQuantity)
        ) {
            return;
        }

        setValue("amount", (safeQuantity / safePerQuantity) * safeRate);
    }, [perQuantity, rate, quantity]);

    useEffect(() => {
        console.log("hello");
        console.log(shipTo);

        const shipToValue = shipTo?.data?.results?.data[0]?.value;
        const sgstValue = sgst?.data?.results?.data[0]?.value;
        const cgstValue = cgst?.data?.results?.data[0]?.value;

        if (shipToValue) {
            setValue("ship_to", shipToValue);
        }
        if (sgstValue) {
            setValue("sgst", sgstValue);
        }
        if (cgstValue) {
            setValue("cgst", cgstValue);
        }
    }, [shipTo?.data, sgst?.data, cgst?.data]);

    useEffect(() => {
        if (suppliers) {
            setValue("supplier", {
                ...suppliers?.[0],
            });
        }
    }, [suppliers]);

    return (
        <>
            <div className="nk-block-head nk-block-head-sm">
                <div className="nk-block-between">
                    <div className="nk-block-head-content">
                        <h4 className="nk-block-title">
                            Create Purchase Order
                        </h4>
                    </div>
                </div>
            </div>
            <div className="col-lg-12 col-md-12 col-sm-12">
                <div className="card">
                    <div className="card-inner">
                        <form
                            onSubmit={handleSubmit(onSubmit)}
                            autoComplete="off"
                        >
                            <div className="row g-4">
                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <label className="form-label">
                                        Item
                                        <span className="fs-8 text-danger">
                                            *
                                        </span>
                                    </label>
                                    <Controller
                                        render={({ field }) => (
                                            <Select
                                                {...field}
                                                options={genericData?.item
                                                    ?.filter(
                                                        (item) =>
                                                            item?.category ===
                                                            "Raw Material"
                                                    )
                                                    ?.map((api) => {
                                                        return {
                                                            value: api?.id,
                                                            label: api?.item_name,
                                                            ...api,
                                                        };
                                                    })}
                                                isLoading={genericDataLoading}
                                                isClearable={true}
                                                id="select-forms-item"
                                                isDisabled={modal}
                                            />
                                        )}
                                        defaultValue=""
                                        rules={{ required: true }}
                                        name="item"
                                        control={control}
                                    />
                                    {errors.item && (
                                        <span className="fs-8 text-danger">
                                            Item is required
                                        </span>
                                    )}
                                </div>
                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <label className="form-label">
                                        Supplier
                                        <span className="fs-8 text-danger">
                                            *
                                        </span>
                                    </label>
                                    <div className="d-flex justify-content-between align-items-center">
                                        <div className="w-100 me-2">
                                            <Controller
                                                render={({ field }) => (
                                                    <Select
                                                        {...field}
                                                        options={
                                                            suppliers
                                                                ? suppliers
                                                                : []
                                                        }
                                                        isLoading={
                                                            genericDataLoading ||
                                                            supplierDataLoading
                                                        }
                                                        isClearable={true}
                                                        id="select-forms-supplier"
                                                    />
                                                )}
                                                defaultValue=""
                                                rules={{ required: true }}
                                                name="supplier"
                                                control={control}
                                            />
                                        </div>
                                        <button
                                            type="button"
                                            className="btn btn-primary btn-sm"
                                            data-bs-toggle="modal"
                                            data-bs-target="#assign-supplier-to-item-modal"
                                            disabled={
                                                !currentItem?.value ||
                                                genericDataLoading ||
                                                supplierDataLoading
                                            }
                                        >
                                            +
                                        </button>
                                    </div>
                                    {errors.supplier && (
                                        <span className="fs-8 text-danger">
                                            Supplier is required
                                        </span>
                                    )}
                                </div>
                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <label className="form-label">
                                        Payment Terms
                                        <span className="fs-8 text-danger">
                                            *
                                        </span>
                                    </label>
                                    <textarea
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter payment terms"
                                        id="textarea-forms-payment_terms"
                                        {...register("payment_terms", {
                                            required: true,
                                        })}
                                    />
                                    {errors.payment_terms && (
                                        <span className="fs-8 text-danger">
                                            Payment terms are required
                                        </span>
                                    )}
                                </div>
                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <label className="form-label">
                                        Billed To
                                        <span className="fs-8 text-danger">
                                            *
                                        </span>
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter billing details"
                                        id="text-forms-billed_to"
                                        {...register("billed_to", {
                                            required: "Filed is required",
                                        })}
                                    />
                                    {errors.billed_to && (
                                        <span className="fs-8 text-danger">
                                            {errors.billed_to?.message}
                                        </span>
                                    )}
                                </div>
                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <label className="form-label">
                                        Ship To
                                        <span className="fs-8 text-danger">
                                            *
                                        </span>
                                    </label>
                                    <textarea
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter ship to"
                                        id="textarea-forms-ship_to"
                                        {...register("ship_to", {
                                            required: true,
                                        })}
                                    />
                                    {errors.ship_to && (
                                        <span className="fs-8 text-danger">
                                            Ship to is required
                                        </span>
                                    )}
                                </div>
                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <label className="form-label">
                                        Terms of Delivery
                                        <span className="fs-8 text-danger">
                                            *
                                        </span>
                                    </label>
                                    <Controller
                                        render={({ field }) => (
                                            <Select
                                                {...field}
                                                options={
                                                    TypeMasterDeliveryStatus.data?.results?.data?.map(
                                                        (tm) => ({
                                                            value: tm?.value,
                                                            label: tm?.name,
                                                        })
                                                    ) ?? []
                                                }
                                                isLoading={
                                                    TypeMasterDeliveryStatus.isLoading ||
                                                    TypeMasterDeliveryStatus.isRefetching
                                                }
                                                isClearable={true}
                                                id="select-forms-terms_of_delivery"
                                            />
                                        )}
                                        defaultValue=""
                                        rules={{ required: true }}
                                        name="terms_of_delivery"
                                        control={control}
                                    />
                                    {errors.terms_of_delivery && (
                                        <span className="fs-8 text-danger">
                                            Terms of delivery are required
                                        </span>
                                    )}
                                </div>
                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <label className="form-label">
                                        Receiving Date
                                        <span className="fs-8 text-danger">
                                            *
                                        </span>
                                    </label>
                                    <input
                                        type="date"
                                        className="form-control"
                                        placeholder="Enter delivery date"
                                        id="date-forms-delivery_date"
                                        min={
                                            new Date()
                                                .toISOString()
                                                .split("T")[0]
                                        }
                                        {...register("delivery_date", {
                                            required: true,
                                        })}
                                    />
                                    {errors.delivery_date && (
                                        <span className="fs-8 text-danger">
                                            Receiving date is required
                                        </span>
                                    )}
                                </div>
                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <label className="form-label">
                                        Quantity
                                        <span className="fs-8 text-danger">
                                            *
                                        </span>
                                    </label>
                                    <div className="input-group">
                                        <input
                                            type="number"
                                            step="any"
                                            className="form-control"
                                            placeholder="Enter quantity"
                                            id="number-forms-quantity"
                                            {...register("quantity", {
                                                required:
                                                    "Quantity is required",
                                                validate: {
                                                    positive: (value) =>
                                                        !value ||
                                                        value > 0 ||
                                                        "Only positive numbers are allowed",
                                                },
                                            })}
                                            onWheel={(e) => e.target.blur()}
                                        />
                                        {currentItem && (
                                            <div className="input-group-append">
                                                <span
                                                    className="input-group-text"
                                                    id="basic-addon2"
                                                >
                                                    {currentItem?.uom}
                                                </span>
                                            </div>
                                        )}
                                    </div>

                                    {errors.quantity && (
                                        <span className="fs-8 text-danger">
                                            {errors.quantity.message}
                                        </span>
                                    )}
                                </div>
                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <label className="form-label">
                                        Rate
                                        <span className="fs-8 text-danger">
                                            *
                                        </span>
                                    </label>
                                    <input
                                        type="number"
                                        step="any"
                                        className="form-control"
                                        placeholder="Enter rate"
                                        id="number-forms-rate"
                                        {...register("rate", {
                                            required: "Rate is required",
                                            validate: {
                                                positive: (value) =>
                                                    !value ||
                                                    value > 0 ||
                                                    "Only positive numbers are allowed",
                                            },
                                        })}
                                        onWheel={(e) => e.target.blur()}
                                    />
                                    {errors.rate && (
                                        <span className="fs-8 text-danger">
                                            {errors.rate.message}
                                        </span>
                                    )}
                                </div>
                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <label className="form-label">
                                        Per Quantity
                                        <span className="fs-8 text-danger">
                                            *
                                        </span>
                                    </label>
                                    <div className="input-group">
                                        <input
                                            type="number"
                                            step="any"
                                            className="form-control"
                                            placeholder="Enter per quantity"
                                            id="number-forms-per_quantity"
                                            {...register("per_quantity", {
                                                required:
                                                    "Per quantity is required",
                                                validate: {
                                                    positive: (value) =>
                                                        !value ||
                                                        value > 0 ||
                                                        "Only positive numbers are allowed",
                                                },
                                            })}
                                            onWheel={(e) => e.target.blur()}
                                        />
                                        {currentItem && (
                                            <div className="input-group-append">
                                                <span
                                                    className="input-group-text"
                                                    id="basic-addon2"
                                                >
                                                    {currentItem?.uom}
                                                </span>
                                            </div>
                                        )}
                                    </div>
                                    {errors.per_quantity && (
                                        <span className="fs-8 text-danger">
                                            {errors.per_quantity.message}
                                        </span>
                                    )}
                                </div>
                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <label className="form-label">
                                        SGST
                                        <span className="fs-8 text-danger">
                                            *
                                        </span>
                                    </label>
                                    <input
                                        type="number"
                                        step="any"
                                        className="form-control"
                                        placeholder="Enter SGST"
                                        id="number-forms-SGST"
                                        {...register("sgst", {
                                            required: "SGST is required",
                                            min: {
                                                value: 0,
                                                message: "cannot be negative",
                                            },
                                        })}
                                        defaultValue={""}
                                        onWheel={(e) => e.target.blur()}
                                    />
                                    {errors.sgst && (
                                        <span className="fs-8 text-danger">
                                            {errors.sgst?.message}
                                        </span>
                                    )}
                                </div>
                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <label className="form-label">
                                        CGST / IGST
                                        <span className="fs-8 text-danger">
                                            *
                                        </span>
                                    </label>
                                    <input
                                        type="number"
                                        step="any"
                                        className="form-control"
                                        placeholder="Enter CGST"
                                        id="number-forms-CGST"
                                        {...register("cgst", {
                                            required: "CGST is required",
                                            min: {
                                                value: 0,
                                                message: "cannot be negative",
                                            },
                                        })}
                                        defaultValue={""}
                                        onWheel={(e) => e.target.blur()}
                                    />
                                    {errors.cgst && (
                                        <span className="fs-8 text-danger">
                                            {errors.cgst?.message}
                                        </span>
                                    )}
                                </div>
                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <label className="form-label">
                                        Transport Amount
                                    </label>
                                    <input
                                        type="number"
                                        step="any"
                                        className="form-control"
                                        placeholder="Enter transport amount"
                                        id="number-forms-transport_amount"
                                        {...register("transport_amount", {
                                            required: false,
                                        })}
                                        onWheel={(e) => e.target.blur()}
                                    />
                                </div>
                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <label className="form-label">
                                        Amount
                                        <span className="fs-8 text-danger">
                                            *
                                        </span>
                                    </label>
                                    <input
                                        type="number"
                                        step="any"
                                        className="form-control"
                                        placeholder="Enter amount"
                                        id="number-forms-amount"
                                        {...register("amount", {
                                            required: true,
                                        })}
                                        onWheel={(e) => e.target.blur()}
                                    />
                                    {errors.amount && (
                                        <span className="fs-8 text-danger">
                                            Amount is required
                                        </span>
                                    )}
                                </div>
                                <div className="col-lg-12 col-md-12 col-sm-12">
                                    <label className="form-label">
                                        Total Amount:
                                    </label>
                                    {/* <span style={{ fontSize: "1.3rem" }}>
                                        {watch("amount")
                                            ? `${Number(watch("amount"))}`
                                            : 0}
                                    </span>{" "}
                                    <sub>Amount</sub> +
                                    <span style={{ fontSize: "1.3rem" }}>
                                        {(
                                            (Number(watch("amount")) *
                                                Number(watch("sgst") || 0)) /
                                            100
                                        ).toFixed(2)}
                                    </span>{" "}
                                    <sub>SGST</sub> +
                                    <span style={{ fontSize: "1.3rem" }}>
                                        {(
                                            (Number(watch("amount")) *
                                                Number(watch("cgst") || 0)) /
                                            100
                                        ).toFixed(2)}
                                    </span>{" "}
                                    <sub>CGST</sub>
                                    {watch("transport_amount") && (
                                        <>
                                            +{" "}
                                            <span
                                                style={{ fontSize: "1.3rem" }}
                                            >
                                                {Number(
                                                    watch("transport_amount")
                                                )}
                                            </span>{" "}
                                            <sub>Transport</sub>
                                        </>
                                    )}
                                    */}
                                    <span className="mx-2">=</span>
                                    <span style={{ fontSize: "1.3rem" }}>
                                        {total}
                                    </span>
                                    <small className="text-info ms-1">
                                        (* Including all amounts)
                                    </small>
                                </div>

                                {/* <div className="col-lg-6 col-md-6 col-sm-12">
                                    <label className="form-label">
                                        Invoice
                                        <span className="fs-8 text-danger">
                                            *
                                        </span>
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter invoice"
                                        id="text-forms-invoice"
                                        {...register("invoice", {
                                            required: true,
                                        })}
                                    />
                                    {errors.invoice && (
                                        <span className="fs-8 text-danger">
                                            Invoice is required
                                        </span>
                                    )}
                                </div> */}
                                <div className="col-12">
                                    <div className="form-group">
                                        {!modal ? (
                                            <button
                                                type="button"
                                                className="btn btn-md btn-light me-2"
                                                id="submit-button-backbutton"
                                                onClick={() => navigate(-1)}
                                            >
                                                Back
                                            </button>
                                        ) : (
                                            <button
                                                type="button"
                                                className="btn btn-md btn-light me-2"
                                                id="submit-button-backbutton"
                                                data-bs-dismiss="modal"
                                            >
                                                Close
                                            </button>
                                        )}
                                        {isPending ? (
                                            <button
                                                type="button"
                                                id="button-product-loading"
                                                className="btn btn-md text-dark"
                                                disabled
                                            >
                                                Loading...
                                            </button>
                                        ) : (
                                            <button
                                                type="submit"
                                                className="btn btn-md btn-primary"
                                                id="submit-button-create-product"
                                            >
                                                Create
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            {!modal && (
                <>
                    <AssignSupplierToItemModal
                        modal={false}
                        currentItem={currentItem}
                        suppliers={suppliers}
                    />
                    <CreateSupplierModal
                        modal={true}
                        goback={false}
                        currentItem={currentItem}
                    />
                </>
            )}
        </>
    );
};

export default CreatePurchaseOrder;
